<template>
  <v-snackbar
    :value="visible"
    :timeout="2000"
    :color="color"
    top
    transition="fab-transition"
    ><v-row class="justify-center font-weight-bold">
      {{ content.toUpperCase() }}</v-row
    >
  </v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  props: ["content", "visible", "color"]
};
</script>
<style scoped></style>
